<template>
  <div id="home">
    <Header></Header>
    <!--    业务范围-->
    <div class="business" id="business">
      <div class="title">
        <div class="word">业务范围</div>
        <div class="describe">我们的服务范畴；希望能帮到你</div>
      </div>
      <div class="businessList">
        <div v-for="(item,index) in businessListData" :key="index" class="businessItem"  @click="inBusinessDetails(item.detailsSrc)">
          <img class="businessImg" :src="item.imgSrc" alt="" width="100%">
          <div class="businessWord">
            <div class="businessTitle">{{ item.title }}</div>
            <div class="businessDescribe">{{ item.describe }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--    关于我们-->
    <div class="aboutUs" id="aboutUs">
      <div class="title">
        <div class="word">关于我们</div>
        <div class="describe">物联网技术服务；计算机软硬件及外围设备制造；工程和技术研究和试验发展等</div>
      </div>
      <div class="briefIntroduction">
        <div class="left">
          <div class="left_title">山东山科智控数字化科技有限公司</div>
          <div class="line"></div>
          <div class="left_word">
            山东山科智控科数字化科技有限公司办公室地址位于山东省会，泉城济南，山东省济南市历下区科院路19号山科众创空间203E，于2021年04月19日在济南市历下区市场监督管理局注册成立，注册资本为350（万元），在公司发展壮大的1年里，我们始终为客户提供好的产品和技术支持、健全的售后服务，我公司主要经营一般项目：物联网技术服务；计算机软硬件及外围设备制造；工程和技术研究和试验发展；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；软件开发；物联网技术研发；信息技术咨询服务；计算机系统服务；互联网数据服务；物联网应用服务；工业自动控制系统装置制造；智能控制系统集成；智能农业管理；软件销售；电子产品销售...
          </div>
          <div class="more">
            <router-link to="/aboutUs"><span style="color: white">查看更多</span></router-link>
          </div>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <!--    项目案例-->
    <div class="project" id="project">
      <div class="title">
        <div class="word">项目案例</div>
        <div class="describe">好的产品和专业的销售和技术团队</div>
      </div>
      <div>
        <projectList :projectListDatas=this.projectListData></projectList>
      </div>
    </div>
    <!--    新闻发布-->
    <div class="news" id="news">
      <div class="title">
        <div class="word">新闻发布</div>
        <div class="describe" style="color: white;opacity:0.8;">动态消息动态消息动态消息动态消息</div>
      </div>
      <el-carousel height="1.7rem" indicator-position="outside">
        <div v-for="(newsItem,index) in newsListdata" :key="index">
          <el-carousel-item v-for="(item,index) in newsItem" :key="index" >
            <div class="newsDiv">
<!--              <div v-for="(data,index) in item" :key="index"  @click="inNewsDetails(data.detailsSrc)">-->
              <div v-for="(data,index) in item" :key="index" >
                <div>
                  <div v-if="data.color==''" class="yuan">{{ data.type }}</div>
                  <div v-else class="yuan" style="background: #469DFF;">{{ data.type }}</div>
                  <div class="kuang">
                    <div class="name"></div>
                    <div class="jieshao">{{ data.describe }}</div>
                    <div class="jieshao" style="text-align: right;line-height: 30px;color: #b6b6b6;">{{ data.time }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </div>
      </el-carousel>
    </div>
    <!--我们的团队-->
    <div class="team">
      <div class="title">
        <div class="word">我们的团队</div>
        <div class="describe">专业 · 协作 · 服务</div>
      </div>
      <div class="flex_div">
        <div v-for="(item,index) in teamtListData" :key="index" class="touxiang_div">
          <img class="touxiang" :src="item.imgSrc" alt="" width="100%">
          <div class="position">{{ item.title }}</div>
        </div>
      </div>
      <div class="team_describe">
        对于一个优秀的团队来说，目标决不仅仅是团队的目标，而是团队目标和个人目标的集合体。一方面，团队需要有自己发展的方向；另一方面，必须明确在团队达到目标的过程中团队的成员可以得到什么，荣誉、经验、培训、认可还是金钱。如果团队要前进，就必须首先帮助团队的成员前进，只要每个成员都能够前进，团队的前进只是水到渠成的事情。
      </div>
    </div>
    <!--    脚部-->
    <Footer></Footer>
  </div>
</template>

<script>
import projectList from "@/components/projectList/projectList";
import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";


export default {
  name: 'home',
  data() {
    return {
      navBarFixed: false,
      //业务范围
      businessListData: [
        {id: 0, imgSrc: require("@/assets/img/zhinengkongzhi.png"),detailsSrc: require("@/assets/img/zhinengkongzhi_details.jpg"), title: '智能控制技术', describe: '设备故障诊断、制造过程智能化集成技术'},
        {id: 1, imgSrc: require("@/assets/img/gongyiguocheng.png"), detailsSrc: require("@/assets/img/gongYIGuoCheng_details.jpg"),title: ' 工艺过程的智能控制', describe: '在线故障监测、诊断'},
        {id: 2, imgSrc: require("@/assets/img/zhinenghuachejian.png"),detailsSrc: require("@/assets/img/zhinengxhejian_details.jpg"), title: '智能化车间一体化', describe: '解决方案'},
        {id: 3, imgSrc: require("@/assets/img/meikuang.png"),detailsSrc: require("@/assets/img/meikuangAQ_details.jpg"), title: '煤矿安全风险智能预警平台 ', describe: '实时预警监控'},
      ],
      //项目案例
      projectListData: [
        {id: 0, imgSrc: require("@/assets/img/nongji.png"),detailsSrc: require("@/assets/img/nongJi_details.jpg"), title: '农机装备网络协同解决方案'},
        {id: 1, imgSrc: require("@/assets/img/mKyuJing.png"), detailsSrc: require("@/assets/img/meuKuang_details.jpg"),title: ' 煤矿安全风险智能预警平台'},
        {id: 2, imgSrc: require("@/assets/img/yuntai.png"), detailsSrc: require("@/assets/img/zhongXiaoQiYe_details.jpg"),title: '中小企业智能制造解决方案'},
        {id: 3, imgSrc: require("@/assets/img/wulianwang.png"),detailsSrc: require("@/assets/img/wuLianWang_details.jpg"), title: '物联网设备OTA解决方案 '},
        {id: 4, imgSrc: require("@/assets/img/kuangjing.png"), detailsSrc: require("@/assets/img/kuangShan_details.jpg"),title: '矿山安全管理APP'},
        {id: 5, imgSrc: require("@/assets/img/nongchang.png"), detailsSrc: require("@/assets/img/zhiHuiNongCHang_details.jpg"),title: '智慧农场管理云服务'}
      ],
      //新闻发布
      newsListdata: [
        {
          newsItem: [
            {id: 0, type: '企业', time: '2021-12-14', describe: '公司于2021年12月14日正式成立', color: '',detailsSrc: require("@/assets/img/news_deteils.jpg")},
            {id: 1, type: '实时', time: '', describe: '暂无', color: '#469DFF',detailsSrc: require("@/assets/img/news_deteils.jpg")},
            {id: 2, type: '项目', time: '', describe: '暂无', color: '',detailsSrc: require("@/assets/img/news_deteils.jpg")},
            {id: 3, type: '人文', time: '', describe: '暂无', color: '#469DFF',detailsSrc: require("@/assets/img/news_deteils.jpg")},
          ],
        },
        // {
        //   newsItem: [
        //     {id: 4, type: '企业', title: '你的标题5', describe: '你的描述5', color: ''},
        //     {id: 5, type: '实时', title: '你的标题6', describe: '你的描述6', color: '#469DFF'},
        //     {id: 6, type: '项目', title: '你的标题7', describe: '你的描述7', color: ''},
        //     {id: 7, type: '人文', title: '你的标题8', describe: '你的描述8', color: '#469DFF'},
        //   ],
        // },
      ],
      //我们的团队
      teamtListData: [
        {id: 0, imgSrc: require("@/assets/img/touXiang.png"), title: '工程师'},
        {id: 1, imgSrc: require("@/assets/img/touXiang.png"), title: '工程师'},
        {id: 2, imgSrc: require("@/assets/img/touXiang.png"), title: '工程师'},
        {id: 3, imgSrc: require("@/assets/img/touXiang.png"), title: '工程师 '},
      ]
    };
  },
  created() {
  },
  mounted() {
  },

  destroyed() {
  },
  components: {
    projectList,
    Footer,
    Header
  },
  methods: {
    inBusinessDetails(detailsSrc){
      this.$router.replace({path:'/projectDetails',query: {detailsSrc:detailsSrc}})
    },
    inNewsDetails(detailsSrc){
      this.$router.replace({path:'/projectDetails',query: {detailsSrc:detailsSrc}})
    },
  }
};
</script>

<style scoped>

body {
  margin: 0;
}

#home {
  height: auto;
}
/*业务范围*/
.business {
  width: 1920px;
  height: 740px;
  background: #FFFFFF;
}

/*关于我们*/
.aboutUs {
  width: 1920px;
  height: 873px;
  background: #F2F5F8;
  opacity: 0.89;
}

/*公共*/
.title {
  width: 1920px;
  height: 230px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.title .word {
  width: 200px;
  height: 39px;
  font-size: 40px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #469DFF;
  text-align: center;
}

.title .describe {
  width: 800px;
  height: 22px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  opacity: 0.51;
  margin-top: 20px;
  text-align: center;
}

.businessList {
  width: 1200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.businessItem {
  margin: 0 30px;
}

.businessImg {
  width: 276px;
  height: 276px;
}

.businessWord {
  width: 276px;
  height: 130px;
  background: #ffffff;
  box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.33);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.businessTitle {
  width: 260px;
  height: 19px;
  font-size: 20px;
  font-family: SourceHanSansCN;
  font-weight: 540;
  color: #000000;
  line-height: 14px;
  margin-bottom: 10px;
  text-align: center;
}

.businessDescribe {
  width: 260px;
  height: 15px;
  font-size: 16px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  text-align: center;
}

.briefIntroduction {
  width: 70%;
  height: 600px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}

.left {
  width: 550px;
  height: 550px;
}

.right {
  width: 600px;
  height: 500px;
  background: url("../assets/img/gs.png") no-repeat;
  background-size: 100%;
  border-radius: 10px;
}

.left_title {
  width: 481px;
  height: 29px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2E2E2E;
  line-height: 33px;
  opacity: 0.72;
}

.line {
  width: 100%;
  height: 3px;
  background-color: #469DFF;
  margin: 10px 0 20px 0;
}

.left_word {
  width: 100%;
  height: 390px;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 545;
  color: #838383;
  line-height: 33px;
  margin-bottom: 40px;
}

.more {
  width: 191px;
  height: 49px;
  background: #469DFF;
  border-radius: 25px;
  font-size: 20px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 49px;
  text-align: center;
}

/*项目案例*/
.project {
  width: 1920px;
  height: 1080px;
  background: white;
}

/*新闻发布*/
.news {
  width: 1920px;
  height: 600px;
  background-image: url("../assets/img/bg.png");
  background-size: 100%;
}

.newsDiv {
  width: 80%;
  display: flex;
  justify-content: space-around;
  text-align: center;
  margin: 0 auto;
}

.yuan {
  width: 114px;
  height: 114px;
  background: #00BE6E;
  border-radius: 50%;
  margin-bottom: -55px;
  margin-left: 85px;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 114px;
}

.kuang {
  position: fixed;
  width: 267px;
  height: 235px;
  background: #FFFFFF;
  border: 1px solid #C1C1C1;
  border-radius: 10px;
  text-align: center;
  z-index: -999;
}

.name {
  width: 260px;
  height: 19px;
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 37px;
  margin-top: 71px;
  margin-bottom: 20px;
  text-align: center;
}

.jieshao {
  width: 265px;
  height: 19px;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 19px;
  text-align: center;
}

.team {
  width: 1920px;
  height: 726px;
}

.flex_div {
  width: 1300px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  margin: 0 auto;
}

.touxiang_div {
  width: 212px;
  text-align: center;
}

.touxiang {
  width: 212px;
  height: 212px;
  border-radius: 50%;
}

.position {
  width: 212px;
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 27px;
  text-align: center;
  margin: 10px auto;
  text-align: center;
}

.team_describe {
  width: 1113px;
  height: 82px;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 30px;
  opacity: 0.51;
  text-align: center;
  margin: 49px auto;
}

el-carousel {
  width: 100%;
}
.businessItem:hover {
  transform:scale(1.2, 1.2);
}
.right:hover {
  transform:scale(1.1, 1.1);
}
</style>

